'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEPAPaymentForm = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _InputField = require('components/FormFields/InputField');

var _StripeElements = require('../StripeElements');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEPAPaymentForm = exports.SEPAPaymentForm = function (_PureComponent) {
  (0, _inherits3.default)(SEPAPaymentForm, _PureComponent);

  function SEPAPaymentForm(props) {
    var _ref;

    (0, _classCallCheck3.default)(this, SEPAPaymentForm);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (_ref = SEPAPaymentForm.__proto__ || (0, _getPrototypeOf2.default)(SEPAPaymentForm)).call.apply(_ref, [this, props].concat(args)));

    _this3.state = {};
    _this3.elementEls = {};

    _this3.renderIbanName = _this3.renderIbanName.bind(_this3);
    _this3.getStripeTokenPromise = _this3.getStripeTokenPromise.bind(_this3);

    props.setStripePromise(_this3.getStripeTokenPromise);
    return _this3;
  }

  (0, _createClass3.default)(SEPAPaymentForm, [{
    key: 'getStripeTokenPromise',
    value: function getStripeTokenPromise() {
      var _this = this;

      var _props = this.props,
          onLoadingStateChanged = _props.onLoadingStateChanged,
          ibanName = _props.ibanName,
          stripe = _props.stripe;


      onLoadingStateChanged(true);

      var extraData = {
        owner: {
          name: ibanName.input.value
        },
        mandate: {
          notification_method: 'manual'
        },
        type: 'sepa_debit',
        currency: 'eur'
      };

      return stripe.createSource(this.elementEls.ibanNumber, extraData).then(function (_ref2) {
        var source = _ref2.source,
            error = _ref2.error;

        if (error) {
          error.isStripeError = true;
          throw error;
        }

        onLoadingStateChanged(false);

        return { source: source.id };
      }).catch(function (err) {
        if (err && err.type !== 'validation_error') {
          _this.setState({ error: err.message });
        }
        onLoadingStateChanged(false);
        throw err;
      });
    }
  }, {
    key: 'renderIbanName',
    value: function renderIbanName(extraProps) {
      var ibanName = this.props.ibanName;


      return _react2.default.createElement(_InputField.InputField, (0, _extends3.default)({}, ibanName, {
        inputAttributes: {
          autoComplete: 'iban-name'
        }
      }, extraProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          ibanName = _props2.ibanName,
          elements = _props2.elements;
      var error = this.state.error;


      var IbanName = this.renderIbanName;

      return _react2.default.createElement(
        'div',
        { className: 'form' },
        error && _react2.default.createElement(
          'div',
          { className: 'grid__item error__text mb' },
          error
        ),
        _react2.default.createElement(
          'ul',
          null,
          ibanName && _react2.default.createElement(IbanName, {
            wrapperTag: 'li',
            label: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'payment-form.ibanNameLabel',
              defaultMessage: 'Name'
            })
          }),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'label',
              { htmlFor: 'iban-number' },
              _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'payment-form.ibanLabel',
                defaultMessage: 'IBAN'
              })
            ),
            _react2.default.createElement(_StripeElements.IbanElement, {
              elements: elements,
              elementRef: function elementRef(el) {
                return _this2.elementEls.ibanNumber = el;
              },
              key: 'iban-number'
            })
          )
        )
      );
    }
  }]);
  return SEPAPaymentForm;
}(_react.PureComponent);

SEPAPaymentForm.propTypes = {
  children: _propTypes2.default.func,
  countryShortCode: _propTypes2.default.string,
  elements: _propTypes2.default.shape({}),
  ibanName: _propTypes2.default.object,
  onEditRequest: _propTypes2.default.func,
  onLoadingStateChanged: _propTypes2.default.func,
  setStripePromise: _propTypes2.default.func,
  stripe: _propTypes2.default.shape({
    getSource: _propTypes2.default.func,
    getToken: _propTypes2.default.func
  })
};